<template>
  <LexmeaFullScreenDialog
    :open="open"
    transition="enter-from-left"
    logoSize="sm"
    sticky
    :headerBorderBottom="true"
    @close="$emit('close')"
  >
    <div class="mx-2">
      <SchemasOverview
        class="mb-5 min-h-0 rounded-xl border border-gray-200 p-2"
        backgroundColor="transparent"
        :columnCollapsed="false"
        :paragraphFol="paragraphFol"
        :collapse="active?.type === 'schema'"
        :titleAsCollapseToggle="true"
      />

      <div v-if="active?.type === 'schema'" class="rounded-lg bg-white px-2">
        <TextEditor
          class="h-full"
          largeTitle
          :entry="active"
          :fieldOfLaw="activeEntryFol"
          :isMainContent="false"
          @close="setActive"
        />
      </div>
    </div>
  </LexmeaFullScreenDialog>
</template>
<script setup lang="ts">
import type { IFieldOfLaw } from "~/models/IFieldOfLaw";

defineProps<{
  open: boolean;
  paragraphFol?: IFieldOfLaw;
  activeEntrySlug: string;
}>();
defineEmits<{
  close: [];
}>();

const { active } = useFetchActiveEntry();
const {
  query: { data: activeEntryFol },
} = useActiveEntryFieldOfLaw();
const { setActive } = useSetActiveEntry();
</script>
